import {
  CREATE_FOLDER,
  GET_FILES,
  OPEN_MODAL,
  RECENT_FILES,
  RECENT_FOLDER,
  SET_CREATE_TYPE,
} from "../../constants/ActionTypes";

const INITIAL_STATE = {
  data: [],
  loading: false,
  fileList: [],
  folderlist: [],
  createType: "",
  recentFolders: [],
  recentFiles: [],
};

const FileManagementReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case OPEN_MODAL: {
      return {
        ...state,
      };
    }

    case CREATE_FOLDER: {
      return {
        ...state,
        folderlist: payload,
      };
    }

    case GET_FILES: {
      return {
        ...state,
        fileList: payload,
      };
    }

    case SET_CREATE_TYPE: {
      return {
        ...state,
        createType: payload,
      };
    }
    case RECENT_FILES: {
      console.log(payload);
      return {
        ...state,
        recentFiles: payload,
      };
    }

    case RECENT_FOLDER: {
      return {
        ...state,
        recentFolders: payload,
      };
    }

    default:
      return state;
  }
};

export default FileManagementReducer;
